/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontFeaturedSection_viewer$ref = any;
export type StorefrontHome_viewer$ref = any;
export type StorefrontHome_viewer = {
    readonly " $fragmentRefs": StorefrontFeaturedSection_viewer$ref;
    readonly " $refType": StorefrontHome_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontHome_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontFeaturedSection_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'e604d626df963f5912fa6bbad941e3b7';
export default node;
